import type { ReactNode } from 'react';
import type { FormField } from '../../types';

interface Props {
  field: FormField;
  error?: string;
  children: ReactNode;
  labelFor?: string;
}

export function FormFieldWrapper({ field, error, children, labelFor }: Props) {
  return (
    <div className="field">
      <label htmlFor={labelFor}>{field.label}{field.required && ' *'}</label>
      {children}
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}
